import React from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { Truck } from "../../../types";
import { colors, getStatusColor } from "../../../utils/colors";
import { formatDateTime } from "../../../utils/dateUtils";
import { ImgDisplay } from "./ImgDisplay";
interface VehicleSummaryProps {
  trucks: Truck[];
  registration: string;
}

export function VehicleSummary({
  trucks,
  registration,
}: VehicleSummaryProps): React.JSX.Element {
  const getLatestTruck = (trucks: Truck[]) => {
    return trucks && trucks.length > 0 ? trucks[0] : null;
  };

  const getAvailabilityStatus = (trucks: Truck[]) => {
    const latestTruck = getLatestTruck(trucks);
    if (!latestTruck) return "Unknown";
    const lastDirection = latestTruck.direction?.toLowerCase() || "";
    return lastDirection === "in" ? "Unavailable" : "Available";
  };

  const latestTruck = getLatestTruck(trucks);
  const availabilityStatus = getAvailabilityStatus(trucks);
  const availabilityColor = getStatusColor(availabilityStatus);

  return (
    <Box
      sx={{
        mb: 3,
        p: 2,
        backgroundColor: colors.background,
        borderRadius: 1,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Stack>
        <Stack direction="row" sx={{ gap: 2, mb: 2 }}>
          <Box
            sx={{
              fontSize: "1.5rem",
              fontFamily: "SigmaSans",
              fontWeight: "bold",
            }}
          >
            {registration}
          </Box>
          <Box
            sx={{
              display: "inline-flex",
              alignItems: "center",
              px: 2,
              py: 0.5,
              borderRadius: 1,
              backgroundColor: availabilityColor,
              color: "white",
              fontSize: "0.875rem",
              fontFamily: "SigmaSans",
              fontWeight: "bold",
            }}
          >
            {availabilityStatus}
          </Box>
        </Stack>
        <Stack sx={{ gap: 1, fontFamily: "SigmaSans" }}>
          <Box>
            <strong>Yard:</strong> {latestTruck?.yard || "N/A"}
          </Box>
          <Box>
            <strong>Last Seen:</strong>{" "}
            {latestTruck?.intime ? formatDateTime(latestTruck.intime) : "N/A"}
          </Box>
          <Box>
            <strong>Direction:</strong> {latestTruck?.direction || "N/A"}
          </Box>
        </Stack>
      </Stack>

      {latestTruck?.adr_url && (
        <Box
          sx={{
            maxWidth: "160px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <ImgDisplay path={latestTruck.adr_url} height={240} />
        </Box>
      )}
    </Box>
  );
}
